var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVliAdminReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48111",
    "data-name": "Group 48111",
    transform: "translate(-1434 -336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1254",
    "data-name": "Ellipse 1254",
    transform: "translate(1434 336)",
    fill: "none",
    stroke: "#a1a3ef",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-person",
    "data-name": "Icon material-person",
    d: "M18.966,18.966a6.483,6.483,0,1,0-6.483-6.483A6.481,6.481,0,0,0,18.966,18.966Zm0,3.241C14.638,22.207,6,24.379,6,28.69v3.241H31.932V28.69C31.932,24.379,23.293,22.207,18.966,22.207Z",
    transform: "translate(1440.034 342.034)",
    fill: "#a1a3ef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVliAdminReview);
export default __webpack_public_path__ + "static/media/VLIAdminReview.7cd73c1ebb20e7c44abf03afaedf45b5.svg";
export { ForwardRef as ReactComponent };